module.exports = __webpack_public_path__ + "img/ИФ-1(А)-039-m.143e9b2b.png";